module.exports = __webpack_public_path__ + "static/img/wawaBottom3.79b5b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawaBottom3.png
// module id = ULm1
// module chunks = 2